import { Injectable } from '@angular/core';

@Injectable()
export class CalendarsService {
  today;
  constructor() {
      this.today = new Date();
      this.today.setHours(0, 0, 0);
  }
    public daysUntil(calendar: Date) {
        console.log(calendar);
        console.log(typeof calendar);
        const theDate = new Date(calendar);
        theDate.setHours(0, 0, 0);
        const dateDiff = theDate.getTime() - this.today.getTime();
        const daysDiff = Math.round(dateDiff / 1000 / 3600 / 24);
        return daysDiff;
    }
}



// WEBPACK FOOTER //
// ./src/app/calendar/calendars.service.ts